<template>
<v-app class="homebg" dark>
<v-container  grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs10 offset-xs1>
          <v-layout row align-center justify-center>
            <v-flex xs12 md6 class="text-xs-center text-sm-left">
              <a href="http://www.notatfaultclaim.com/" target="_blank" rel="noreferrer" title="G4 Claims"><img src="../assets/logo-title.png" style="max-width:180px;" alt="G4 Claims logo"></a>
            </v-flex>
            <v-flex v-if="!$vuetify.breakpoint.xsOnly" xs9 md6 class="text-xs-right">
              <a href="http://www.notatfaultclaim.com/" target="_blank" rel="noreferrer" title="G4 Claims" class="accent--text title font-weight-bold"> back to main site</a>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center justify-center :class='marginSize'>
            <v-flex xs12 sm7  class="text-xs-left">
              <h1 :class='headingSize' class="font-weight-bold">A handy new app for our customers.</h1>
              <v-layout row align-center justify-center pt-1 >
                <v-flex xs2>
                  <svg class="checks" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.667 426.667"><path d="M293.333 135.04L190.08 240.213l-52.907-53.12-28.373 28.374 83.413 83.2 133.974-129.92z"/><path d="M213.333 0C95.513 0 0 95.513 0 213.333s95.513 213.333 213.333 213.333 213.333-95.513 213.333-213.333S331.154 0 213.333 0zm0 388.053c-96.495 0-174.72-78.225-174.72-174.72s78.225-174.72 174.72-174.72c96.446.117 174.602 78.273 174.72 174.72 0 96.496-78.224 174.72-174.72 174.72z"/></svg>
                </v-flex>
                <v-flex xs10 >
                  <p>
                    Photograph/upload all your insurance documents so they can be easily accessed any time you need them.
                  </p>
                </v-flex>
              </v-layout>
              <v-layout row align-center justify-center pt-1  >
                <v-flex xs2>
                  <svg class="checks" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.667 426.667"><path d="M293.333 135.04L190.08 240.213l-52.907-53.12-28.373 28.374 83.413 83.2 133.974-129.92z"/><path d="M213.333 0C95.513 0 0 95.513 0 213.333s95.513 213.333 213.333 213.333 213.333-95.513 213.333-213.333S331.154 0 213.333 0zm0 388.053c-96.495 0-174.72-78.225-174.72-174.72s78.225-174.72 174.72-174.72c96.446.117 174.602 78.273 174.72 174.72 0 96.496-78.224 174.72-174.72 174.72z"/></svg>
                </v-flex>
                <v-flex xs10>
                  <p>
                    Follow our handy ‘step by step’ guide on what to do if you‘re ever in a crash.
                  </p>
                </v-flex>
              </v-layout>
              <v-layout row align-center justify-center pt-1  >
                <v-flex xs2>
                  <svg class="checks" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.667 426.667"><path d="M293.333 135.04L190.08 240.213l-52.907-53.12-28.373 28.374 83.413 83.2 133.974-129.92z"/><path d="M213.333 0C95.513 0 0 95.513 0 213.333s95.513 213.333 213.333 213.333 213.333-95.513 213.333-213.333S331.154 0 213.333 0zm0 388.053c-96.495 0-174.72-78.225-174.72-174.72s78.225-174.72 174.72-174.72c96.446.117 174.602 78.273 174.72 174.72 0 96.496-78.224 174.72-174.72 174.72z"/></svg>
                </v-flex>
                <v-flex xs10>
                  <p>
                    Phone our 24 hr support team.
                  </p>
                </v-flex>
              </v-layout>
              <v-layout row align-center justify-center pt-1  >
                <v-flex xs12>
                  <v-btn href="/sign-up" color="accent" class="secondary--text headline font-weight-bold text-lowercase mt-4" block large depressed>get it for free :)</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row align-center justify-center pt-3  >
                <v-flex class="text-xs-center">
                  <p class="pt-2 accent--text font-weight-bold mx1">Already a user? <v-btn to="/documents" small depressed outline color="accent">Sign in</v-btn></p>

                </v-flex>
              </v-layout>
              <v-layout row align-center justify-center pt-3  >
                <v-flex class="text-xs-center">
                  <a href="https://www.facebook.com/G4ClaimsLtd/" title="Facebook" target="_blank" rel="noreferrer noopener"><svg class="sm" xmlns="http://www.w3.org/2000/svg" width="49.652" height="49.652"><path d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zM31 25.7h-4.039v14.396h-5.985V25.7h-2.845v-5.088h2.845v-3.291c0-2.357 1.12-6.04 6.04-6.04l4.435.017v4.939h-3.219c-.524 0-1.269.262-1.269 1.386v2.99h4.56L31 25.7z"/></svg></a>
                  <a href="https://twitter.com/G4ClaimsLtd" title="Twitter" target="_blank" rel="noreferrer noopener"><svg class="sm" xmlns="http://www.w3.org/2000/svg" width="49.652" height="49.652"><path d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zm11.075 19.144c.011.246.017.494.017.742 0 7.551-5.746 16.255-16.259 16.255-3.227 0-6.231-.943-8.759-2.565.447.053.902.08 1.363.08 2.678 0 5.141-.914 7.097-2.446a5.72 5.72 0 0 1-5.338-3.969 5.76 5.76 0 0 0 2.58-.096 5.715 5.715 0 0 1-4.583-5.603l.001-.072a5.69 5.69 0 0 0 2.587.714 5.71 5.71 0 0 1-2.541-4.755c0-1.048.281-2.03.773-2.874a16.225 16.225 0 0 0 11.777 5.972 5.707 5.707 0 0 1-.147-1.303 5.714 5.714 0 0 1 9.884-3.91 11.406 11.406 0 0 0 3.63-1.387 5.74 5.74 0 0 1-2.516 3.162 11.36 11.36 0 0 0 3.282-.899 11.494 11.494 0 0 1-2.848 2.954z"/></svg></a>
                  <a href="https://www.instagram.com/g4claimsltd/" title="Instagram" target="_blank" rel="noreferrer noopener"><svg class="sm" xmlns="http://www.w3.org/2000/svg" width="49.652" height="49.652"><path d="M24.825 29.796a4.978 4.978 0 0 0 4.972-4.97 4.954 4.954 0 0 0-.94-2.897 4.964 4.964 0 0 0-4.029-2.073c-1.659 0-3.126.82-4.031 2.072a4.947 4.947 0 0 0-.94 2.897 4.973 4.973 0 0 0 4.968 4.971zM35.678 18.746V13.96l-.623.002-4.164.013.016 4.787z"/><path d="M24.826 0C11.137 0 0 11.137 0 24.826c0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826C49.652 11.137 38.516 0 24.826 0zm14.119 21.929v11.56a5.463 5.463 0 0 1-5.457 5.458H16.164a5.462 5.462 0 0 1-5.457-5.458V16.165a5.462 5.462 0 0 1 5.457-5.457h17.323a5.463 5.463 0 0 1 5.458 5.457v5.764z"/><path d="M32.549 24.826c0 4.257-3.464 7.723-7.723 7.723s-7.722-3.466-7.722-7.723a7.67 7.67 0 0 1 .568-2.897h-4.215v11.56a2.706 2.706 0 0 0 2.706 2.704h17.323a2.707 2.707 0 0 0 2.706-2.704v-11.56h-4.217c.367.894.574 1.873.574 2.897z"/></svg></a>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1 class="text-xs-left">
                <img src="../assets/phone.png" alt="G4 Claims app - Example screenshot">
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
</v-app>
</template>

<script>

export default {
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    headingSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'display-1 pb-3'
        case 'sm': return 'display-2 pb-3'
      }
      return 'display-3 pb-3'
    },
    marginSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'mt-3 mb-3'
        case 'sm': return 'mt-3 mb-0'
      }
      return 'mt-3 mb-0'
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        // if there is a billing issue go there
        let whereTo
        whereTo = this.$route.query.from || '/documents'
        this.$router.push(whereTo)
      }
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
    }
  },
  mounted () {
    if (this.user) {
      this.$router.push('/documents')
    }
  }
}
</script>

<style scoped>
.homebg{
  background:#ee264d;
  /* height:100vh; */
}
img{
  max-width:100%;
}
.checks{
  fill:#fdc056;
  width:40px;
}
.sm{
  fill:#fff;
  margin:0 10px;
}
</style>
